import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Předpokládáme cestu k vašemu AuthContext
import { apiFetch } from '../services/apiService';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Container } from 'react-bootstrap';
import Header from './Header';

function Login() {
    const [email, setEmail] = useState('renata@maugliherna.cz');
    const [password, setPassword] = useState('');
    const { login } = useAuth(); // Použití funkce login z AuthContext
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const data = await apiFetch('/api/users/login', {
                method: 'POST',
                body: JSON.stringify({ email, password }),
            });

            login(data.user, data.token); // Aktualizace stavu přihlášení
            navigate('/'); // Přesměrování na domovskou stránku po úspěšném přihlášení
        
        } catch (error) {
            console.error('Chyba při pokusu o přihlášení:', error);
        }
    };

    return (
        <div className='vh-100'>
            <Header />
            <Container className='align-items-center col-8 col-md-4 d-flex flex-column h-100 justify-content-center'>

                <h1 className='display-6 text-center'>Přihlášení</h1>

                <Form onSubmit={handleSubmit} className='mt-5 mx-auto w-100'>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Váš přihlašovací e-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}

                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Heslo</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Heslo"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" className='w-100 py-2 mt-2'>
                        Přihlásit
                    </Button>
                </Form>
            </Container>

        </div>

    );
}

export default Login;